module.exports = {
	baseUrl : '/',
	globalUrl : 'https://covert-ai.gdn8.work/',
	dist : 'dist/staging',
	pwa : true
}